<template>
  <div class="card pl-3">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <pie-chart
      :height="350"
      ref="pieChart"
      :chart-data="chartData"
      :extraOptions="extraOptions"
    ></pie-chart>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  import PieChart from '../../Charts/PieChart';

  export default {
    name: 'chart-pie',
    components: {
      PieChart
    },
    props: {
      extraOptions: {
        type: Object,
        default: () => {
          return {}
        }
      },
      chartData: {
        type: Object,
        default: () => {
          return {
            labels: [],
            datasets:[]
          }
        }
      },
    },
    created(){

    }
  }
</script>
<style>

</style>
